import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { UserModel } from '../_models/user.model';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from './../_config/config';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  gateway = this.config.getGateway();
  url= `${this.gateway.urlSeguridad}/lbw/seguridad`;

  constructor(private http: HttpClient, private config: CONFIG) { 
    this.gateway = this.config.getGateway();
    //this.gateway ="https://aeuecpasilab01q.red.ecopetrol.com.co";
    
  }

  authLogin(user: any) {
    let datasend = new URLSearchParams();
    datasend.set('grant_type', 'password');
    datasend.set('username', `${user.username}###DCATECH2019###${user.password}###DCATECH2019###${user.datasource.name}`);
    datasend.set('password', user.password);

    try {
      return this.http.post(`${this.url}/oauth/token`, datasend.toString());
    } catch (error) {
      console.log('Error login');
    }
  }

  getDatasource() {
    try {
      return this.http.get('/../assets/config/labviewer_config.json');
    } catch (error) {
      console.log('Error login data source');
    }
  }

  /* getUrlParent() {
    // ejecucion de paginas especificas del sistema asociado (Labvantage)
    try{
      return this.http.get(`${this.gateway.url}/master/getExternalSource`);
    }catch(error){
      console.log('Error External Source');
    }
  } */

  isLoggedIn(): boolean {
    // indica si el usuario se encuentra registrado o no.
    if (sessionStorage.getItem('token')) {
      return true;
    }
    return false;
  }

  currentUser(): string {
    // indica si el usuario se encuentra registrado o no.
    if (sessionStorage.getItem('user')) {
      const username = sessionStorage.getItem('username');
      return username;
    }
    return null;
  }

}
